import { ComponentBase } from "../components/ComponentBase.js";

/**
 * Tagged template literal function. Takes a literal and returns a HTML Collection. Literal can contain the following expression values:
 * -String (or basic types that can be converted to strings such as Number)
 * -Element
 * -Array<HTMLCollection>
 * -HTMLCollection
 * @returns HTMLCollection
 */
function template(strings, ...interpolatedValues) {
    const idPrefix = 'template_replace_';
    let id = 0;
    const replaceMap = {};

    function addtoReplaceMap(el) {
        const str = `<div id="${idPrefix}${id}"></div>`;
        replaceMap[id] = el;
        id++;
        return str;
    }

    const htmlString = strings.reduce((total, current, index) => {
        total += current;
        if (interpolatedValues.hasOwnProperty(index)) {
            const node = interpolatedValues[index];
            if (node instanceof ComponentBase) {
                total += addtoReplaceMap(node.el);
            }
            else if (node instanceof Element) {
                total += addtoReplaceMap(node);
            }
            else if (Array.isArray(node)) {
                node.forEach(subNode => {
                    for (const el of subNode) {
                        total += addtoReplaceMap(el);
                    }
                })
            } 
            else if (node instanceof HTMLCollection) {
                for (const el of node) {
                    total += addtoReplaceMap(el);
                }
            }
            else if (node instanceof unsafeString) {
                // Don't escape unsafeHTML
                total += node.string;
            }
            else {
                // total += String(node).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
                total += escapeString(node);
            }
        }
        return total;
    }, '');
    const el = document.createElement('div');
    el.innerHTML = htmlString;

    // Replace div placeholders with actual Elements
    for (const id in replaceMap) {
        el.querySelector(`#${idPrefix}${id}`).replaceWith(replaceMap[id]);
    }

    // TODO: This returns nothing if the template literal only has text. Consider el.childNodes
    return el.children;
}

function unsafeHTML(str) {
    return new unsafeString(str);
}

class unsafeString{
    constructor(str) {
        this.string = str;
    }
}

// Escapes special characters for HTML rendering and preventing XSS
function escapeString(str) {
    const entities = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
    };

    return String(str).replace(/[&<>"]/g, (match) => entities[match]);
}

export {
    template,
    unsafeHTML,
    escapeString,
}